import {
  clientsContractsListQueryKey,
  leadsContractsListQueryKey,
  opportunitiesContractsListQueryKey
} from '@crm/api'
import { client } from '@crm/api/client.gen'
import { useInvalidatePredicateQueries } from '@shared/hooks'
import { useLocales } from '@shared/locales'
import { showApiErrors } from '@shared/utils'
import { useMutation } from '@tanstack/react-query'
import { notification } from 'antd'
import { useParams } from 'react-router-dom'

export const useFetchSiAsig = () => {
  const { t } = useLocales()
  const { invalidateQueries } = useInvalidatePredicateQueries()
  // `id` is the lead id on lead routes and the client id on client routes
  const { id, opportunityId } = useParams()

  return useMutation({
    mutationFn: (contractId: number) =>
      client.request({
        method: 'POST',
        url: `/contracts/${contractId}/fetch-si-asig`,
        throwOnError: true
      }),
    onSuccess: () => {
      invalidateQueries([
        leadsContractsListQueryKey({ path: { lead_id: String(id) } }),
        clientsContractsListQueryKey({ path: { client_id: String(id) } })
      ])

      if (opportunityId) {
        invalidateQueries([
          opportunitiesContractsListQueryKey({
            path: { opportunity_id: String(opportunityId) }
          })
        ])
      }

      notification.success({
        message: t('success.success'),
        description: t('contracts.fetch_si_asig_success')
      })
    },
    onError: (error) => showApiErrors(error)
  })
}
